// Legal content (GDPR compliant) for Norway + EU, in Norwegian and English.
// Displayed in modal dialogs. Placeholders ([...]) are to be completed by the
// business owner before launch.
import { BUSINESS } from "@/data/content";

const A = BUSINESS.address;
const BRAND = BUSINESS.brand;
const EMAIL = BUSINESS.email;

export const LEGAL = {
  privacy: {
    no: {
      title: "Personvernerkl\u00e6ring",
      updated: "Sist oppdatert: [dato]",
      sections: [
        {
          h: "1. Behandlingsansvarlig",
          p: `${BRAND}, ${A}, org.nr ${BUSINESS.orgnr}, er behandlingsansvarlig for personopplysningene som samles inn via dette nettstedet. Kontakt: ${EMAIL}.`,
        },
        {
          h: "2. Hvilke opplysninger vi behandler",
          p: "N\u00e5r du kontakter oss via WhatsApp, behandles telefonnummeret ditt og innholdet i meldingen for \u00e5 svare p\u00e5 foresp\u00f8rselen din. WhatsApp leveres av Meta Platforms Ireland Ltd. Nettstedet lagrer valgene dine for informasjonskapsler lokalt i nettleseren.",
        },
        {
          h: "3. Behandlingsgrunnlag",
          p: "Vi behandler opplysninger basert p\u00e5 ditt samtykke (GDPR art. 6(1)(a)) og for \u00e5 kunne svare p\u00e5 og oppfylle en foresp\u00f8rsel/avtale (art. 6(1)(b)). Analyse skjer kun med ditt samtykke.",
        },
        {
          h: "4. Lagringstid",
          p: "Vi lagrer henvendelser s\u00e5 lenge det er n\u00f8dvendig for \u00e5 f\u00f8lge opp foresp\u00f8rselen din, og deretter sletter vi dem. Anonyme analysedata lagres i inntil 14 m\u00e5neder.",
        },
        {
          h: "5. Dine rettigheter",
          p: "Du har rett til innsyn, retting, sletting, begrensning og dataportabilitet, samt rett til \u00e5 trekke tilbake samtykke n\u00e5r som helst. Du kan klage til Datatilsynet (www.datatilsynet.no).",
        },
        {
          h: "6. Kontakt",
          p: `For sp\u00f8rsm\u00e5l om personvern, kontakt oss p\u00e5 ${EMAIL}.`,
        },
      ],
    },
    en: {
      title: "Privacy Policy",
      updated: "Last updated: [date]",
      sections: [
        {
          h: "1. Data controller",
          p: `${BRAND}, ${A}, org. no. ${BUSINESS.orgnr}, is the controller of personal data collected through this website. Contact: ${EMAIL}.`,
        },
        {
          h: "2. Data we process",
          p: "When you contact us via WhatsApp, we process your phone number and the content of your message in order to respond to your request. WhatsApp is provided by Meta Platforms Ireland Ltd. The website stores your cookie choices locally in your browser.",
        },
        {
          h: "3. Legal basis",
          p: "We process data based on your consent (GDPR Art. 6(1)(a)) and to respond to and fulfil a request/agreement (Art. 6(1)(b)). Analytics is only performed with your consent.",
        },
        {
          h: "4. Retention",
          p: "We keep inquiries for as long as necessary to follow up your request, then delete them. Anonymous analytics data is stored for up to 14 months.",
        },
        {
          h: "5. Your rights",
          p: "You have the right to access, rectification, erasure, restriction and data portability, and to withdraw consent at any time. You may lodge a complaint with the Norwegian Data Protection Authority (www.datatilsynet.no).",
        },
        {
          h: "6. Contact",
          p: `For privacy questions, contact us at ${EMAIL}.`,
        },
      ],
    },
  },

  terms: {
    no: {
      title: "Vilk\u00e5r og betingelser",
      updated: "Sist oppdatert: [dato]",
      sections: [
        {
          h: "1. Om tjenesten",
          p: `${BRAND} tilbyr skj\u00f8nnhetsbehandlinger ved ${A}. Priser og timer avtales via WhatsApp eller ved oppm\u00f8te.`,
        },
        {
          h: "2. Booking og avbestilling",
          p: "Timer bestilles etter avtale. Vi ber om at avbestilling skjer i god tid. Ved gjentatt uteblivelse kan vi kreve bekreftelse ved fremtidige bestillinger.",
        },
        {
          h: "3. Priser",
          p: "Priser oppgis p\u00e5 foresp\u00f8rsel og kan variere ut fra behandlingens omfang. Endelig pris bekreftes f\u00f8r behandling.",
        },
        {
          h: "4. Ansvar",
          p: "Informer oss om allergier, hudtilstander eller helsemessige forhold f\u00f8r behandling. Vi tar forbehold om \u00e5 avsl\u00e5 behandling av hensyn til helse og sikkerhet.",
        },
        {
          h: "5. Angrerett",
          p: "For avtalte tjenester som utf\u00f8res p\u00e5 et bestemt tidspunkt gjelder forbrukerkj\u00f8psloven og angrerettlovens bestemmelser om tjenester.",
        },
        {
          h: "6. Verneting",
          p: "Disse vilk\u00e5rene reguleres av norsk rett. Tvister s\u00f8kes l\u00f8st i minnelighet, og ellers ved Oslo tingrett.",
        },
      ],
    },
    en: {
      title: "Terms & Conditions",
      updated: "Last updated: [date]",
      sections: [
        {
          h: "1. About the service",
          p: `${BRAND} provides beauty treatments at ${A}. Prices and appointments are arranged via WhatsApp or on site.`,
        },
        {
          h: "2. Booking and cancellation",
          p: "Appointments are made by arrangement. We ask that cancellations are made in good time. In case of repeated no-shows we may require confirmation for future bookings.",
        },
        {
          h: "3. Prices",
          p: "Prices are provided on request and may vary depending on the scope of the treatment. The final price is confirmed before treatment.",
        },
        {
          h: "4. Liability",
          p: "Please inform us of any allergies, skin conditions or health matters before treatment. We reserve the right to decline treatment for health and safety reasons.",
        },
        {
          h: "5. Right of withdrawal",
          p: "For agreed services performed at a specific time, the Norwegian Consumer Purchases Act and the Right of Withdrawal Act provisions for services apply.",
        },
        {
          h: "6. Governing law",
          p: "These terms are governed by Norwegian law. Disputes are sought resolved amicably, otherwise before Oslo District Court.",
        },
      ],
    },
  },

  cookies: {
    no: {
      title: "Informasjonskapsler (cookies)",
      updated: "Sist oppdatert: [dato]",
      sections: [
        {
          h: "1. Hva er informasjonskapsler?",
          p: "Informasjonskapsler er sm\u00e5 tekstfiler som lagres i nettleseren din. Vi bruker dem for at nettstedet skal fungere og \u2013 med ditt samtykke \u2013 for analyse.",
        },
        {
          h: "2. N\u00f8dvendige",
          p: "Lagrer sp\u00e5kvalg og samtykke til informasjonskapsler. Disse er n\u00f8dvendige og kan ikke sl\u00e5s av.",
        },
        {
          h: "3. Analyse (valgfritt)",
          p: "Brukes kun hvis du samtykker. Hjelper oss \u00e5 forst\u00e5 bruk av nettstedet slik at vi kan forbedre det. Ingen analyse lastes f\u00f8r du gir samtykke.",
        },
        {
          h: "4. Endre valg",
          p: "Du kan n\u00e5r som helst endre valget ditt via \u00abCookie-innstillinger\u00bb nederst p\u00e5 siden.",
        },
      ],
    },
    en: {
      title: "Cookies",
      updated: "Last updated: [date]",
      sections: [
        {
          h: "1. What are cookies?",
          p: "Cookies are small text files stored in your browser. We use them to make the website work and \u2013 with your consent \u2013 for analytics.",
        },
        {
          h: "2. Essential",
          p: "Store your language choice and cookie consent. These are necessary and cannot be turned off.",
        },
        {
          h: "3. Analytics (optional)",
          p: "Used only if you consent. Helps us understand how the site is used so we can improve it. No analytics is loaded before you give consent.",
        },
        {
          h: "4. Change your choice",
          p: "You can change your choice at any time via \u201cCookie settings\u201d at the bottom of the page.",
        },
      ],
    },
  },
};
